module.exports = __webpack_public_path__ + "img/sv16.8c080439.svg";